/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Fragment, useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';

import Button from '../../../juristec-ui/core/Button';
import IconButton from '../../../juristec-ui/core/IconButton';
import Select from '../../../juristec-ui/core/SelectNew';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';
import Tooltip from '../../../juristec-ui/core/Tooltip';

import FieldMap from './FieldMap';
import getFieldGroups from './groups';

import { Finder, Reload } from '../../../juristec-ui/icons';

import {
  MainContainer,
  ToolbarContainer,
  SideBarContainer,
  ActionsGroupContainer,
  FormContainer,
  ToolbarLeft,
  ToolbarRight,
  SeparatorLine,
} from './styled/ManageInstance.styled';

const initialState = {
  dashboards: 100000,
  monitoring: 0,
  newMonitoring: 0,
  newProcess: 0,
  oldProcess: 0,
  disabled: false,
  templates: [],
  support: null,
};

const removeList = [
  'id', 'value', 'label', 'emailsSuper', 'emailsScientist', 'diskSize',
];

const filterSeach = (field, search) => (
  field.toLowerCase().includes(search.toLowerCase().trim())
);

const ManageInstance = ({
  plans, editData = undefined, close, submit,
}) => {
  const cron = useRef();

  const [config, setConfig] = useState(initialState);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [filteredFields, setFilteredFields] = useState(getFieldGroups(!!editData));
  const [tempState, setTempState] = useState(null);
  const [fSearch, setFSearch] = useState('');

  const setConfigValues = (valuesObj) => {
    setConfig((cfg) => ({
      ...cfg,
      ...valuesObj,
    }));
  };

  const setPlanConfig = ({
    fields, plan, lastPlan = {}, savedData = {}, reset = false,
  }) => {
    const auxState = [...fields.values()].reduce((aux, flist) => {
      flist.forEach((f) => {
        if (reset) {
          aux[f.kWord] = (
            f.genFormatedState(plan[f.kWord])
            ?? f.genFormatedState(savedData[f.kWord])
            ?? config[f.kWord]
            ?? f.getDefaultState()
          );
        } else {
          const val = (
            config[f.kWord]
            ?? f.genFormatedState(savedData[f.kWord])
            ?? f.genFormatedState(plan[f.kWord])
            ?? f.getDefaultState()
          );
          if (lastPlan[f.kWord] !== undefined && val.value === lastPlan[f.kWord]) {
            aux[f.kWord] = (
              f.genFormatedState(savedData[f.kWord])
              ?? f.genFormatedState(plan[f.kWord])
              ?? config[f.kWord]
              ?? f.getDefaultState()
            );
          } else aux[f.kWord] = val;
        }
        if (f.kWord === 'push') {
          aux[f.kWord] = f.genFormatedState(plan.value === 'push');
        }
      });
      return aux;
    }, { ...plan });
    setConfigValues({ ...auxState, plan: plan.value });
  };

  const handleSelectPlan = (selected) => {
    setPlanConfig({
      fields: getFieldGroups(!!editData),
      plan: selected,
      lastPlan: selectedPlan,
      savedData: editData,
    });
    setSelectedPlan(selected);
  };

  useEffect(() => {
    document.getElementById('instance-form-container')?.scrollTo(0, 0);
    handleSelectPlan(
      plans[editData?.plan ?? 'advanced']
      ?? Object.values(plans)[0],
    );
  }, []);

  const resetPlanValues = () => {
    setPlanConfig({
      fields: getFieldGroups(!!editData),
      plan: selectedPlan,
      savedData: editData,
      reset: true,
    });
  };

  const handleValues = (valuesObj) => {
    clearTimeout(cron.current);
    setTempState(valuesObj);
    cron.current = setTimeout(() => {
      setConfigValues(valuesObj);
      setTempState(null);
    }, 200);
  };

  const handleFSearch = (e) => {
    clearTimeout(cron.current);
    const val = e.target.value;
    setFSearch(val);
    cron.current = setTimeout(() => {
      if (val.trim().length > 0) {
        setFilteredFields((m) => {
          const tempMap = new Map();
          const iter = m.entries();
          for (let next = iter.next(); !next.done; next = iter.next()) {
            tempMap.set(
              next.value[0],
              next.value[1].filter((f) => filterSeach(f.label, val)),
            );
          }
          return tempMap;
        });
      } else setFilteredFields(getFieldGroups(!!editData));
    }, 200);
  };

  const handleSubmit = () => {
    let errorKey = null;
    const configData = Object.entries(config).reduce((aux, [k, v]) => {
      if (v?.error) errorKey = k;
      else if (!removeList.includes(k)) {
        aux[k] = v?.formatedValue ?? v?.value ?? v;
      }
      return aux;
    }, {});
    if (errorKey) {
      document.getElementById(`field-${errorKey}`)
        .scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    if (editData) {
      configData.company_id = editData.id;
      configData.disabled = editData.disabled;
      configData.templates = editData.templates;
      configData.support = editData.support;
      submit(configData, editData?.photoUrl ?? '');
    } else {
      submit(
        configData,
        config.emailsSuper.formatedValue,
        config.emailsScientist.formatedValue,
        editData?.photoUrl ?? '',
      );
    }
  };

  return (
    <MainContainer>
      <ToolbarContainer>
        <ToolbarLeft>
          <span>Plano base</span>
          <Select
            options={Object.values(plans) ?? []}
            value={selectedPlan}
            onChange={handleSelectPlan}
            styleContainer={{ marginLeft: '5px' }}
            atModal
          />
          <Tooltip text="Resetar campos modificados do plano" atModal>
            <IconButton
              color="secondary"
              size="small"
              onClick={resetPlanValues}
              style={{
                margin: '6px 0 0 5px',
                boxShadow: 'none',
                fontSize: '10px',
                padding: '2px',
                minWidth: 'auto',
              }}
              shape="rounded"
              variant="contained"
            >
              <Reload />
            </IconButton>
          </Tooltip>
        </ToolbarLeft>
        <ToolbarRight>
          <Finder />
          <InputTextLine
            label=""
            placeholder="filtrar campos..."
            value={fSearch}
            onChange={handleFSearch}
            wrapperStyle={{ width: '50%' }}
          />
        </ToolbarRight>
      </ToolbarContainer>
      <SideBarContainer>
        {[...filteredFields.entries()].map(([group, fields], i) => (fields.length > 0 ? (
          <FieldMap key={`map-group-${group}`} groupName={group} fields={fields} startsOpen={i === 0} />
        ) : null))}
      </SideBarContainer>
      <FormContainer id="instance-form-container">
        {[...filteredFields.entries()].map(([group, fields]) => (fields.length > 0 ? (
          <Fragment key={`group-${group}`}>
            <SeparatorLine />
            {fields.map((field) => (
              field.renderComponent(tempState, { ...config, isEdit: !!editData }, handleValues)
            ))}
          </Fragment>
        ) : null))}
      </FormContainer>
      <ActionsGroupContainer>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
        >
          {editData ? 'Salvar' : 'Criar'}
        </Button>
      </ActionsGroupContainer>
    </MainContainer>
  );
};

ManageInstance.propTypes = {
  plans: PropTypes.shape({
    advanced: PropTypes.shape({}),
  }).isRequired,
  editData: PropTypes.shape({
    plan: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    templates: PropTypes.arrayOf(PropTypes.shape({})),
    support: PropTypes.string,
    photoUrl: PropTypes.string,
  }),
  close: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default ManageInstance;
